import { CardInfoCollapseProps } from "@repo/core/components/layout/CardInfoCollapse/types";

export const useCardInfoCollapseController = ({
  isActive
}: Pick<CardInfoCollapseProps, "isActive">) => {
  const bgColor = isActive ? "$primary0" : "$backgroundLight50";
  const borderColor = isActive ? "$primary700" : "$backgroundLight100";

  return {
    bgColor,
    borderColor
  };
};
